import React from 'react';
import * as serverRenderingUtils from 'helpers/serverRenderingUtils';
import { SupportedLocales } from '../types';

type LocaleProviderValue = {
  changeLocale: (newLocale: SupportedLocales) => void;
  enableI18N: boolean;
  locale: SupportedLocales;
  showPseudoLang: boolean;
};

export const LocaleContext = React.createContext<LocaleProviderValue>({
  changeLocale: () => {},
  enableI18N: true,
  locale: 'en',
  showPseudoLang: false,
});

const isDevelopment = (hostname: string) =>
  /localhost/.test(hostname) ||
  /development.anchor.fm/.test(hostname) ||
  /website-(.+).anchor.fm/.test(hostname);

export function LocaleProvider({
  locale = 'en',
  children,
}: {
  locale?: SupportedLocales;
  children: React.ReactNode;
}): React.ReactElement {
  const enableI18N = true;
  const showPseudoLang =
    !serverRenderingUtils.windowUndefined() &&
    isDevelopment(window.location.hostname);
  const [currentLocale, setCurrentLocale] = React.useState<SupportedLocales>(
    locale
  );

  const changeLocale = (requestedLocale: SupportedLocales) => {
    // Safety check to not run the changeLanguage function when unneccessary
    if (requestedLocale === currentLocale) {
      /* eslint-disable-next-line no-console */
      console.log('The preferred language is already set: ', currentLocale);
      return;
    }

    setCurrentLocale(requestedLocale);
  };

  return (
    <LocaleContext.Provider
      value={{
        locale: currentLocale as SupportedLocales,
        enableI18N,
        changeLocale,
        showPseudoLang,
      }}
    >
      {children}
    </LocaleContext.Provider>
  );
}
